import { render, staticRenderFns } from "./reactivate_wrestler.vue?vue&type=template&id=67f346ce&"
import script from "./reactivate_wrestler.vue?vue&type=script&lang=js&"
export * from "./reactivate_wrestler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports